/** Parse a recharge in currency units without rounding fractional cents. */
export function initialCreditCents(value: string | number | null): string | null {
  const text = String(value ?? '').trim().replace(',', '.')
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null
  const [whole, fraction = ''] = text.split('.')
  const cents = BigInt(whole!) * 100n + BigInt(fraction.padEnd(2, '0'))
  // The API stores micro-cents in int64 columns and accepts up to 14 cents digits.
  return cents > 0n && cents <= 99_999_999_999_999n ? cents.toString() : null
}

/** Currency input value, preserving cents exactly. */
export function initialCreditInput(cents: string): string {
  const amount = BigInt(cents)
  return `${amount / 100n}.${(amount % 100n).toString().padStart(2, '0')}`
}
